import { Component, ViewChild } from '@angular/core';

import { SubtasksComponent } from './subtasks/subtasks.component';
import { TasksFilterButtonComponent } from './tasks-filter-button/tasks-filter-button.component';

const DEBUG = true;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  @ViewChild('app-subtasks') stepsView?: SubtasksComponent;
  @ViewChild('app-tasks-filter-button') filterButton?: TasksFilterButtonComponent;
  signedIn = false;

  constructor() {
    if (DEBUG) {console.log('new AppComponent()');}
  }

  onStatusChange($event: boolean): void {
    this.signedIn = $event;
  }
}
